import React from 'react'

export default function Summary() {
    return (
        <>
            <div className='bg-summarybg px-6 sm:pl-8 lg:pl-16 xl:pl-64 xl:pr-64 p-6 ' id='summary_id'>
                <span className='block mb-4'><p >summary</p></span>
                <span className='block mb-4'><p>am bodasingi bhanu prasad, currently a project engineer at wipro. my professional experience includes migrating tibco service to spring boot applications and working within agile development models.  i graduated with an 8.11 gpa from gmr institute of technology with a b-tech in mechanical engineering. i completed java full stack training from stackroute and acquired a certification as a java full stack developer with skills in java, javascript, typescript, html, css, spring boot, angular, react, mysql, git, bootstapcss, tailwindcss and microservice Architecture. i have developed several projects, including full-stack e-commerce and blog apps, a react.js movie app, an exam portal and a cricket player app.
                    </p></span>
                    <span className='block'><p>you can reach me at bodasingibhanuprasad@gmail.com or +918466983155</p></span>
            </div>
        </>
    )
}
